import { render, staticRenderFns } from "./TaxedPaidTicket.vue?vue&type=template&id=53ceb478&scoped=true&"
import script from "./TaxedPaidTicket.vue?vue&type=script&lang=js&"
export * from "./TaxedPaidTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ceb478",
  null
  
)

export default component.exports